<header *ngIf="showHeader" class="app-header">
  <!-- global header placeholder (fixed). If you have a real header component, replace this with <app-header> -->
</header>

<main class="app-main" [class.no-header]="!showHeader" style="padding-bottom: var(--footer-height, 56px); box-sizing: border-box;">
    <app-toast-message></app-toast-message>
<app-loader></app-loader>
  <router-outlet></router-outlet>
</main>

<!-- Global footer included on every page -->
<!-- spacer to prevent fixed footer from covering page content -->
<div class="footer-spacer" style="height: var(--footer-height, 56px); width:100%;"></div>
<app-footer></app-footer>